module.exports = __webpack_public_path__ + "img/546.504361b1.jpg";